/**
 * TanStack Router: /my-business-targets
 *
 * This route file was auto-generated by the route generation script.
 * Component: MyBusinessTargetsPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import MyBusinessTargetsPage from '@/app/my-business-targets/page'

/**
 * Route: /my-business-targets
 * Layout: _auth (authenticated)
 * Component: MyBusinessTargetsPage
 */
export const Route = createFileRoute('/_auth/my-business-targets')({
  component: MyBusinessTargetsPage,
})
